import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React, { useMemo, useState } from 'react';
import { BwjPageContent } from '../../../../framework/components/bwj-page-content';
import { useNavigator } from '../../../../framework/services/navigation';
import { AppRoutes, toProjectSlug, useProjectOverviewParams } from '../../../app-routes';
import { ProjectOverviewService } from '../../services/project-overview';
import { BwjImageBrowser, IBrowserImage } from '../../../../framework/components/bwj-image-browser';
import { forEach, where } from '../../../../framework/utils/collection';
import { BwjViewManager, BwjViewState } from '../../../../framework/components/bwj-view-manager';
import { isMeaningfulString } from '../../../../framework/utils/string';

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    width: 800,
    margin: '0 auto',
  };

  return mergeStyleSets({
    root,
  });
}

export const PageProjectOverviewInstallationSitePhotos: React.FunctionComponent = () => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const nav = useNavigator();
  const { id: projectId, site } = useProjectOverviewParams();
  const installSite = ProjectOverviewService.getInstallationSite(site!)!;
  if(!installSite) {
    nav.goTo(AppRoutes.projectOverview.url(toProjectSlug(projectId)));
  }
  const [imageIndex, setImageIndex] = useState(0);
  const images = useMemo(() => {
    const allImgs: IBrowserImage[] = [{ src: installSite.referencePhotoUrl }];
    forEach(installSite.doorInstallations, di => {
      forEach(di.assessmentPhotoUrls, src => {
        allImgs.push({ src });
      });
    });
    forEach(installSite.completedInstallationPhotoUrls, src => {
      allImgs.push({ src });
    });
    return where(allImgs, i => isMeaningfulString(i.src));
  }, [installSite]);
  const viewState = images.length > 0 ? BwjViewState.Ready : BwjViewState.NoSearchResults;

  return (
    <BwjViewManager
      state={viewState}
      noSearchResultsState={{
        icon: AppRoutes.projectOverviewInstallSitePhotos.icon,
        message: 'No photos associated with this work area',
      }}
    >
      <BwjPageContent contentDescription={'primary content (no subcontent)'}>
        <div className={cs.root}>
          <BwjImageBrowser
            images={images}
            displayIndex={imageIndex}
            loadImages={true}
            imageWidth={800}
            onDisplayIndexChanged={index => setImageIndex(index)}
            widthToHeightRatio={1}
          />
        </div>
      </BwjPageContent>
    </BwjViewManager>
  );
};
